import type { Translator } from '@/i18n/translator';
import { useAppState } from './useAppState';

/** The translator for the current locale. */
export function useT(): Translator {
  return useAppState().i18n;
}
